var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurvedLine = function SvgCurvedLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 346,
    height: 568,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00EA90",
    strokeWidth: 6,
    d: "M564.25 111.275c0 154.461-.056 318.824-.056 346.671 0 27.847-9.87 64.236-46.596 88.989-35.594 23.991-91.318 24.065-119.11-2.97-27.793-27.035-343.436-336.345-364.337-355.9-20.9-19.555-42.625-62.626-22.773-118.074S75.896 5.33 101.703 4.34c25.808-.991 323.585 0 355.347 0 31.763 0 57.571 4.95 76.43 22.772 23.953 22.636 30.77 44.557 30.77 84.162Z"
  })));
};
export default SvgCurvedLine;